import { useEffect } from 'react';
import { inputType } from '../components/MASROIEstimator';
export interface priceProps {
  partNumber: string;
  pricingIndicator: string;
  pricingModel: number;
  scaleQtyPrice: [
    {
      qty: number;
      price: number;
    },
  ];
}

export const setPrice = (
  input: inputType,
  setMaintenanceTotal: React.Dispatch<React.SetStateAction<number>>,
  setReduceExtMaintTotal: React.Dispatch<React.SetStateAction<number>>,
  setReduceDowntimeCostTotal: React.Dispatch<React.SetStateAction<number>>,
  setExtendAssetLifeTotal: React.Dispatch<React.SetStateAction<number>>,
  setIncreaseMROTotal: React.Dispatch<React.SetStateAction<number>>,
  setAssetMgmtToolsTotal: React.Dispatch<React.SetStateAction<number>>,
  setEstimatedSavings: React.Dispatch<React.SetStateAction<number>>,
) => {
  useEffect(() => {
    const MaintenanceTotal = Math.round(
      input.maintenanceFTEs *
        (input.maintenancePersonProd / 100) *
        input.maintenanceAnnualFTERate,
    );
    const ReduceExtMaintTotal = Math.round(
      input.extMaintenanceVendSpend *
        (input.extMaintenanceVendSpendReduce / 100),
    );
    const ReduceDowntimeCostTotal = Math.round(
      input.downTimeHours *
        (input.downTimeReduce / 100) *
        input.downTimeCostPerHour,
    );
    const ExtendAssetLifeTotal = Math.round(
      input.replaceAssetBudget * (input.assetsLifeExtension / 100),
    );
    const IncreaseMROTotal = Math.round(
      input.mroSpend * (input.mroOverSpendReduce / 100),
    );
    const AssetMgmtToolsTotal = Math.round(
      input.assetMgmtToolCost * (input.assetMgmtCostReduce / 100),
    );
    const EstimatedSavings = Math.round(
      MaintenanceTotal +
        ReduceExtMaintTotal +
        ReduceDowntimeCostTotal +
        ExtendAssetLifeTotal +
        IncreaseMROTotal +
        AssetMgmtToolsTotal,
    );
    setMaintenanceTotal(MaintenanceTotal),
      setReduceExtMaintTotal(ReduceExtMaintTotal),
      setReduceDowntimeCostTotal(ReduceDowntimeCostTotal),
      setExtendAssetLifeTotal(ExtendAssetLifeTotal),
      setIncreaseMROTotal(IncreaseMROTotal),
      setAssetMgmtToolsTotal(AssetMgmtToolsTotal),
      setEstimatedSavings(EstimatedSavings);
  }, [input]);
};
